import * as React from 'react';
import classnames from 'classnames';
import { TokenColor } from 'cosmos-tokens-badoo-mobile/badoo/core-token-types';

export interface TextProps {
    children: React.ReactNode;
    size:
        | 'display-1'
        | 'display-2'
        | 'display-3'
        | 'header-1'
        | 'header-2'
        | 'header-3'
        | 'header-4'
        | 'action'
        | 'action-small'
        | 'action-mini'
        | 'p-title'
        | 'p-1'
        | 'p-2'
        | 'p-3';
    tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';
    weight?: 'regular' | 'medium' | 'semibold' | 'bold';
    align?: 'left' | 'center' | 'right' | 'inherited';
    color?:
        | TokenColor.Brand
        | TokenColor.Generic
        | TokenColor.Mono
        | TokenColor.Providers
        | TokenColor.Features
        | TokenColor.Status;
    inline?: boolean;
    ellipsis?: boolean;
    breakWords?: boolean;
    dangerous?: boolean;
    a11y?: {
        ariaHidden?: boolean;
    };
    dataQA?: {
        [dataQaAttribute: string]: string;
    };
    extraClass?: string;
    onClick?: (event: MouseEvent) => void;
}

export const Text: React.FC<TextProps> = ({
    children,
    size,
    tag = 'span',
    weight,
    align,
    color,
    inline,
    ellipsis,
    breakWords,
    dangerous,
    a11y,
    dataQA,
    extraClass,
    onClick,
}) => {
    const className = classnames({
        [`csms-${size}`]: true,
        [`csms-font-weight-${weight}`]: weight,
        [`csms-text-align-${align}`]: align,
        'csms-text-ellipsis': ellipsis,
        'csms-text-break-words': breakWords,
        [`csms-text-color-${color}`]: color,
        [extraClass as string]: extraClass!,
    });

    const Tag = tag;
    let style: React.CSSProperties = {};

    if (inline && tag !== 'span') {
        style = {
            display: 'inline',
        };
    }

    if (!inline && tag === 'span') {
        style = {
            display: 'block',
        };
    }

    if (dangerous) {
        return (
            <Tag
                className={className}
                dangerouslySetInnerHTML={{ __html: children as string }}
                style={style}
                aria-hidden={a11y?.ariaHidden}
                // @ts-ignore
                onClick={onClick}
                {...dataQA}
            />
        );
    } else {
        return (
            <Tag
                className={className}
                style={style}
                aria-hidden={a11y?.ariaHidden}
                // @ts-ignore
                onClick={onClick}
                {...dataQA}
            >
                {children}
            </Tag>
        );
    }
};

export default Text;
